import { createContext, useContext, ReactNode } from 'react';
import { useAuth, AuthProfile, AuthStatus } from '@/hooks/useAuth';
import { User as FirebaseUser } from 'firebase/auth';

interface AuthContextType {
  user: FirebaseUser | null;
  profile: AuthProfile | null;
  agentName: string | null; // User's claimed agent name (null if not claimed)
  loading: boolean;
  error: Error | null;
  authStatus: AuthStatus;
  // Twitter auth
  signInWithX: () => Promise<void>;
  // General auth methods
  signOut: () => Promise<void>;
  clearError: () => void;
  // API key methods
  regenerateApiKey: () => Promise<string>;
  refreshUserDetails: () => Promise<void>;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export function AuthProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();

  return (
    <AuthContext.Provider value={auth}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuthContext() {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuthContext must be used within an AuthProvider');
  }
  return context;
}

// Re-export types for convenience
export type { AuthProfile, AuthStatus };
